module.exports = __webpack_public_path__ + "static/Awareness-7c9bd2595f7e3f5abcb653d5bc369e13.svg";